import { render, staticRenderFns } from "./TeamRow.vue?vue&type=template&id=1b8e805f&scoped=true"
import script from "./TeamRow.vue?vue&type=script&lang=js"
export * from "./TeamRow.vue?vue&type=script&lang=js"
import style0 from "./TeamRow.vue?vue&type=style&index=0&id=1b8e805f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e805f",
  null
  
)

export default component.exports